import { render, staticRenderFns } from "./CardGauge50.vue?vue&type=template&id=1907d596&scoped=true"
import script from "./CardGauge50.vue?vue&type=script&lang=ts"
export * from "./CardGauge50.vue?vue&type=script&lang=ts"
import style0 from "./CardGauge50.vue?vue&type=style&index=0&id=1907d596&prod&lang=css"
import style1 from "./CardGauge50.vue?vue&type=style&index=1&id=1907d596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1907d596",
  null
  
)

export default component.exports